import { useEffect, useState } from "react";

/**
 * Whether the document tab is visible (`document.visibilityState === "visible"`).
 *
 * Intentionally does **not** require `document.hasFocus()`. Gating polls on window
 * focus stops AI status refetch when DevTools, the IDE, or another app takes focus
 * while the tab is still visible — leaving PENDING overlays stuck until a hard reload.
 */
export const usePageVisibility = (): boolean => {
  const [isVisible, setIsVisible] = useState<boolean>(() => {
    if (typeof document !== "undefined") {
      return document.visibilityState === "visible";
    }
    return true;
  });

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsVisible(document.visibilityState === "visible");
    };

    handleVisibilityChange();
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return isVisible;
};
